import { useTranslation } from 'react-i18next'

import { ErrorOverlayData, useOverlayActions } from '@store'

import { OverlayLayout } from '../OverlayLayout'
import styles from './ErrorOverlay.module.scss'

export const ErrorOverlay = ({
  description,
  onClose,
}: ErrorOverlayData['payload']) => {
  const { t } = useTranslation()
  const { hideOverlay } = useOverlayActions()

  const handleClose = () => {
    hideOverlay()
    onClose?.()
  }

  return (
    <OverlayLayout>
      <div className={styles.modalContent}>
        <svg
          viewBox="0 0 20 20"
          fill="none"
          className={styles.closeIcon}
          onClick={handleClose}
        >
          <line x1="3.8" y1="4.1" x2="15.9" y2="16.1" stroke="white" />
          <line x1="15.9" y1="3.9" x2="3.8" y2="15.9" stroke="white" />
        </svg>
        <div className={styles.textContainer}>
          <div className={styles.title}>{t('errorOverlay.title')}</div>
          <div className={styles.description}>{t(description)}</div>
        </div>
      </div>
    </OverlayLayout>
  )
}
